<template>
  <div class="main-container">

    <div class="mastercourses">
      <Loader v-if="coursesLoading || statusesLoading" />
      <template v-else>
        <div class="new-and-filter">
          <h3>{{ t('mastercourses.MASTER_COURSES') }}</h3>
          <div class="new-and-filter__btns">
            <div class="dropdown">
              <input type="checkbox" ref="status__filter" id="status__filter">
              <label class="dropdown__face" for="status__filter">
                {{ params.statusFilter !== '' ? $t(`contents.mastercourses.${statuses.find(status => status.id === params.statusFilter)?.name}`) : t('mastercourses.STATUS')  }}
                <span class="material-icons">keyboard_arrow_down</span>
              </label>
              <ul class="dropdown__items">
                <li @click="selectStatus(status.id)" v-for="(status) in statuses" :key="status.id">{{ $t(`contents.mastercourses.${status.name}`) }}</li>
                <li @click="selectStatus('')">Todos</li>
              </ul>
            </div>
            <form @submit.prevent="params.pageNumber = 0;getCourses()" >
              <label class="new-and-filter__search" for="search">
                <input type="text" :placeholder="t('mastercourses.SEARCH_PLACEHOLDER')" id="search" name="search" v-model="params.filter" />
                <i  @click.prevent="params.pageNumber = 0;getCourses()" class="material-icons-outlined">search</i>
              </label>
            </form>
          </div>
        </div>

          <div ref="table" class="table-pagination">
            <div class="table__container">

              <table class="table">
                <thead class="table__head">
                  <tr class="table__head__row">
                    
                    <!-- <th style="display: flex; align-items: center; justify-content: center;">
                                  <input type="checkbox" class="table__checkbox" @click.stop="togleAll" />
                              </th> -->
                    <th class="table__header table__head__row__title">{{ t('mastercourses.TEMPLATE_NAME') }}</th>
                    <th class="table__header table__header--date table__head__row__date">{{ t('mastercourses.CREATION_DATE') }}</th>
                    <th class="table__header table__head__row__author">{{ t('mastercourses.AUTHOR') }}</th>
                    <th class="table__header table__head__row__status">{{ t('mastercourses.STATUS') }}</th>
                    <th class="table__header table__head__row__options"></th>
                    <div></div>
                      <!-- <th style="display: flex; align-items: center; justify-content: center;">
                                      <input type="checkbox" v-model="row.checked" class="table__checkbox" />
                                  </th> -->
                  </tr>
                </thead>
                <tbody class="table__body">
                  <tr class="table__body__row" v-for="course in courses?.data" :key="course.courseCfgId">
                    <td class="table__body__row__title">
                      <i v-if="course.isFavorite" style="color: #F7B844; font-size: 20px;" class="material-icons">star</i>
                      {{ course.isFavorite ? course.name : course.internalName }}
                    </td>
                    <td class="table__body__date">
                      {{ formatDate(course.createdDate) }}
                    </td>
                    <td class="table__body__row__created">{{ course.createdUser }}</td>
                    <td class="table__body__row__status">
                      <span
                        :class="`--${statuses.find(status => status.id === course.status)?.name}`"
                      >
                        {{ $t(`contents.mastercourses.${statuses.find(status => status.id === course.status)?.name}`) }}
                      </span>
                    </td>
                    <td @click="moreOptionsOpen[course.courseCfgId] = !moreOptionsOpen[course.courseCfgId]" ref="moreOptions" class="table__body__row__options" >
                      <div>
                        <i class="material-icons">more_vert</i><!--Más opciones-->
                      </div>
                    </td>
                    <!-- <transition name="fade"> -->
                    <div v-if="moreOptionsOpen[course.courseCfgId]" class="table__modal-options">
                      <div @click="router.replace(`/contents/mastercourses/${course.courseCfgId}/edit`)" v-if="course.status === 0 && !course.isFavorite || course.status === 1">
                        <i class="material-icons-outlined">mode_edit_outline</i>{{ t('global.EDIT') }}
                      </div>
                      <div @click="router.replace(`/contents/mastercourses/${course.courseCfgId}/copy`)">
                        <i class="material-icons-outlined">content_copy</i>{{ t('mastercourses.MAKE_A_COPY') }}
                      </div>
                      <div @click="changeStatus(course.courseCfgId, 'PUBLISHED')" :disabled="changeStatusLoading" v-if="course.status === 1">
                        <i class="material-icons-outlined">upload_file</i> {{ t('mastercourses.PUBLISH') }}
                      </div>
                      <div v-if="course.status !== 2 && course.status !== 1 && !course.isFavorite" :disabled="changeStatusLoading" @click="changeStatus(course.courseCfgId, 'DISABLED')" >
                        <i class="material-icons-outlined">block</i> {{ t('mastercourses.DISABLE') }}
                      </div>
                      <div v-else-if="course.status !== 1 && !course.isFavorite" :disabled="changeStatusLoading" @click="changeStatus(course.courseCfgId, 'PUBLISHED')" >
                        <i class="material-icons-outlined">check_circle_outline</i> {{ t('mastercourses.ENABLE') }}
                      </div>

                    </div>

                  <!-- </transition> -->
                  </tr>
                </tbody>
              </table>
              
              <div v-if="!courses?.data.length" className="management__noResults" style="padding:20px 0 20px 0;text-align:center">
                {{ t('mastercourses.NO_RESULTS') }}
              </div>
              
            </div>

            <div class="pagination">
              <button class="prev-next" @click="prevPage()" :disabled="params.pageNumber == 0">
                <i class="material-icons">arrow_back</i><span>{{ t('mastercourses.PREVIOUS') }}</span> </button>
              <div class="page"><span>{{ t('mastercourses.PAGE') }} {{ params.pageNumber + 1 }}</span> / {{ courses?.totalPages }}</div>
              <button class="prev-next" @click="nextPage()" :disabled="params.pageNumber + 1 == courses?.totalPages"><span>{{ t('mastercourses.NEXT') }}</span> <i
                  class="material-icons">arrow_forward</i></button>

            </div>

          </div>

      </template>
    </div>
  </div>
</template>

<script>
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import Loader from '@/components/Loader.vue';
import { useRouter } from 'vue-router';
import { onClickOutside } from '@vueuse/core';
import { useI18n } from 'vue-i18n';


export default {
  components: {
    Loader
  },
  setup() {
    const { t } = useI18n();

    const store = useStore()
    const router = useRouter()
    const formatDate = inject('formatDate');
    const status__filter = ref()
    const moreOptionsOpen = ref({
      0: false
    })
    const courses = ref()
    const coursesLoading = ref(true)
    const statusesLoading = ref(true)
    const statuses = ref()
    const changeStatusLoading = ref()
    const moreOptions = ref()
    const params = ref({
      filter: '',
      statusFilter: 0,
      pageNumber: 0
    })

    const changeStatus = async (coursecfg ,status) => {
      if(changeStatusLoading.value) return
      try {
        changeStatusLoading.value = true
        let body = {
          courseCfgId: coursecfg,
          status
        }
        await store.dispatch('courses_patchstatus', body)
        params.value.pageNumber = 0;
        params.value.statusFilter = parseInt(Object.keys(statuses.value).find((propiedad) => statuses.value[propiedad].name === status));
        moreOptionsOpen.value = {}
        getCourses();
        store.dispatch('notifications_create', { text: t('mastercourses.STATUS_UPDATED') })
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('global.ERROR_OCCURRED') })
      } finally {
        changeStatusLoading.value = false
      }
    }

    const getCourses = async () => {
      try {
        params.value.filter = params.value.filter.trim()
        coursesLoading.value = true
        const { data } = await store.dispatch('courses_cfgGet', params.value)
        courses.value = data
        courses.value.totalPages = Math.ceil(data.totalResults / 5);
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('mastercourses.ERROR_LOADING_DATA') })
      } finally {
        coursesLoading.value = false 
      }
    }

    const getStatuses = async () => {
      try {
        statusesLoading.value = true
        const { data } = await store.dispatch('courses_cfgstatuses')
        statuses.value = data
      } catch (err) {
        console.log(err)
        store.dispatch('notifications_create', { text: t('mastercourses.ERROR_LOADING_DATA') })
      } finally {
        statusesLoading.value = false
      }
    }

    const prevPage = () => {
      if (params.value.pageNumber > 0) {
        params.value.pageNumber--
        getCourses()
      }
    }

    const nextPage = () => {
      if (params.value.pageNumber < courses.value.totalPages) {
        params.value.pageNumber++
        getCourses()
      }
    }

    const selectStatus = status => {
      params.value.statusFilter = status
      params.value.pageNumber = 0
      getCourses()
    }

    onClickOutside(moreOptions, () => moreOptionsOpen.value = {})
    onClickOutside(status__filter, () => status__filter.value.checked = false)

    onMounted(() => {
      getCourses()
      getStatuses()
    }) 

    return {
      moreOptionsOpen,
      courses,
      coursesLoading,
      params,
      formatDate,
      router,
      statusesLoading,
      statuses,
      moreOptions,
      status__filter,
      changeStatusLoading,
      t,

      getCourses,
      selectStatus,
      prevPage,
      nextPage,
      changeStatus 
    }

  }
}
</script>


<style lang="scss" scoped>
@import '@/styles/main.scss';

.fade-enter-active, .fade-leave-active {
  transition: all 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.fade-enter-active {
  animation: appear .2s;
}
@keyframes appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.disabled {
  opacity: .6;
  cursor: default !important;
}

.main-container {
  padding: 8px;
  background: #fff;
  min-height: fit-content;
}


.dropdown {
  &__items {
    padding: 8px 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 2;
    font-size: 13px;
    font-weight: 600;
    border: none;

    li {
      padding: 4px 24px;
      cursor: pointer;

      &:hover {
        background: rgba(189, 228, 228, 0.5);
      }
    }

    @media screen and (max-width: 750px) {
      right: 0 !important;
    }
  }
}

.management {
    &__noResults {
        display: grid;
        padding: 20px 0 20px 0;
        text-align: center;
        grid-column-start: 1;
        grid-column-end: 7;
    }

}

.mastercourses {
  width: fit-content;
  max-width: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;

  h1 {
    font-size: 25px;
    font-weight: 700;
  }

  .tabs {
    display: flex;
    margin: 30px 0;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);

    >div {
      height: 60px;
      width: 180px;
      @include flex-column;
      justify-content: center;
      font-size: 15px;
      font-weight: 600;

      &.--selected {
        color: $green;
        border-bottom: 2px solid $green;
      }
    }
  }

  .new-and-filter {
    position: relative;
    min-height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 485px){
      flex-direction: column;
      gap: 12px;
    }
    &__search {
      input {
        border: none;

        &::placeholder {
          font-size: 12px;
        }
      }

      border: 1px solid $black;
      padding: 6px 18px;
      border-radius: 999px;
      display: flex;
      align-items: center;
      position: relative;

      .material-icons-outlined {
        position: absolute;
        font-size: 14px;
        right: 18px;
      }
    }

    h3 {
      font-size: 20px;
    }

    &__btns {
      display: flex;
      gap: 16px;
      align-items: center;

      @media screen and (max-width: 750px) {
        @include flex-column;
        padding-bottom: 16px;
      }

      button {
        @include icon-and-text-container;
        font-size: 12px;

        &.open-filters {
          border: 1px solid;
          border-radius: 16px;
          padding: 6px 18px;
          font-weight: 400;
          gap: 18px;
          height: fit-content;

          .material-icons {
            font-size: 18px;
          }
        }
      }
    }

    .modal-filters {
      position: absolute;
      top: 50px;
      padding: 8px 0;
      display: flex;
      flex-direction: column;
      gap: 6px;
      background: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      z-index: 2;
      font-size: 13px;
      font-weight: 600;

      div {
        padding: 4px 24px;
        cursor: pointer;

        &:hover {
          background: rgba(189, 228, 228, 0.5);
        }
      }

      @media screen and (max-width: 750px) {
        right: 0 !important;
      }
    }

    .modal-country-filters {
      right: 126px;
    }

    .modal-coordinator-filters {
      right: 240px;
    }

    .modal-status-filters {
      right: 0;
    }
  }

//   .table__modal-options {
//     position: absolute;
//     top: 50px;
//     right: 2px;
//     min-width: 215px !important;
//     display: flex;
//     flex-direction: column;
//     gap: 8px;
//     background: #fff;
//     box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
//     border-radius: 10px;
//     z-index: 8000;
//     padding: 6px 0;
//     >button {
//         padding: 4px 22px;
//         @include icon-and-text-container;
//         font-size: 13px;
//         font-weight: 600;
//         cursor: pointer;
//         padding: 4px 22px;
//         color: #212121;
//         &:hover {
//             background: rgba(189, 228, 228, 0.5);
//         }
//     }
// }

.table__modal-options{
    position: absolute;
    // top: 50px;
    margin-top: 10px;
    right: 2px;
    min-width: 215px !important;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 8000;
    >div{
        padding: 4px 22px;
        @include icon-and-text-container;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        &:hover{
            background: rgba(189, 228, 228, 0.5);
        }
    }

    .disabled {
        cursor: not-allowed;
        opacity: 0.5;
    
    }
}


  .table-pagination {
        border-radius: 10px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    }
    @media(max-width:980px) {
        .table__container {
            overflow-x: auto;
        }
    }
    .table {
        width: 100%;
        position: relative;
        margin-top: 8px;
        padding: 16px;
        padding-bottom: 0;

        th, td {
            padding: 14px;
        }

        &__head {
            
            
            &__row {
                th {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-weight: 600;
                    font-size: 12px;
                    text-align: left;

                    &.table__head__row__options {
                      padding-right: 0;
                      padding-left: 0;
                    }
                    &.table__head__row__title {
                      padding-left: 0;
                    }
                    &.table__head__row__stage {
                    position: relative;
                    .material-icons-outlined{
                        font-size: 14px;
                    }
                    .stage-tooltip{
                        width: 200px;
                        position: absolute;
                        // top: -28px;
                        right: -36px;
                        padding: 18px 14px 26px 14px;
                        background: #BDE4E4;
                        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                        border-radius: 10px;
                        text-align: left;
                        font-size: 11px;
                        font-weight: 400;
                        z-index: 100;
                        h4{
                            padding-bottom: 4px;
                            font-size: 13px;
                            font-weight: 700;
                        }
                    }
                }
                }
            }
        }

        &__body {
            tr {
                td {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 11px;
                    text-align: left;
                    border-bottom: 1px solid #eee;

                    max-width: 210px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;

                    &.table__body__row__title {
                        font-weight: 600;
                        font-size: 12px;
                        padding-left: 0;
                        // display: flex;
                        // align-items: center;
                        gap: 8px;

                        // max-width: 210px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;

                        i {
                          font-size: 20px;
                          position: relative;
                          top: 4px;
                        }
                    }


                    &.table__body__row__status {
                        // padding-top: 4px !important;
                        // text-align: center;
                        span{
                            display: inline-block;
                            // width: 100px;
                            // width: 100%;
                            // max-width: 160px;
                            padding: 4px 24px;
                            border-radius: 50px;
                            font-size: 12px;
                            font-weight: 600;
                            text-align: center;
                            &.--DISABLED {
                              background-color: #F5705526;
                              color: #F57055;
                            }

                            &.--PUBLISHED {
                              color: #009696;
                              background: rgba(189, 228, 228, 0.50);
                            }

                            &.--DRAFT {
                              background: rgba(255, 178, 63, 0.15);
                              color: #FFB23F;
                            }
                        }
                    }

                    &.table__body__row__options {
                        font-size: 12px;
                        font-weight: 600;
                        cursor: pointer;
                        // display: flex;
                        // align-items: center;
                        // justify-content: flex-end;
                        padding-left: 0;
                        padding-right: 0;
                        width: 28px;
                        div {
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                        }          
                    }
                }
            }
        }

    }
    .pagination{
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 24px 16px;
        .prev-next{
            @include icon-and-text-container;
            font-size: 15px;
            font-weight: 600;
            color: $green;
            line-height: 20px;
            &:disabled{
                cursor: default;
            }
            .material-icons{
                font-size: 20px;
            }
        }
        .page{
            font-size: 15px;
            font-weight: 400;
            span{
                font-weight: 700;
            }
        }
    }

  .unsuscribeUser {
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-width: 460px;
    padding: 0 40px;

    h3 {
      font-weight: 700;
      font-size: 16px;
    }

    span {
      font-size: 14px;
    }

    &__buttons {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      gap: 24px;

      button {
        border: 1px solid $green;
        text-align: center;
        width: fit-content;
        display: flex;
        align-items: center;
        gap: 12px;
        border-radius: 999px;
        padding: 12px 18px;

        .material-icons-outlined {
          font-size: 18px;
        }

        &:first-child {
          color: $green;
        }

        &:last-child {
          color: #fff;
          background-color: $green;
        }
      }
    }
  }
}</style>